const DoubleArrowIcon = ({ className = "", id = "", onClick = () => {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 -960 960 960"
      width="1em"
      //   fill="#e3e3e3"
      className={className}
      id={id}
      onClick={onClick}
    >
      <path d="m242-200 200-280-200-280h98l200 280-200 280h-98Zm238 0 200-280-200-280h98l200 280-200 280h-98Z" />
    </svg>
  )
}

export default DoubleArrowIcon
